import '@planilla/ui/tokens.css';
import './estilos/base.css';
import './estilos/componentes.css';
import './estilos/marco.css';
import './estilos/paginas.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorDeApi } from './api/cliente';
import { App } from './App';
import { ProveedorAvisos } from './componentes/Avisos';
import { ProveedorSesion } from './sesion/sesion';

const consultas = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      refetchOnWindowFocus: true,
      // Un 4xx no se arregla reintentando: se muestra. Y un 409 del mostrador menos que nada.
      retry: (intentos, error) => !(error instanceof ErrorDeApi && error.estado < 500) && intentos < 2,
    },
  },
});

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={consultas}>
      <BrowserRouter>
        <ProveedorAvisos>
          <ProveedorSesion>
            <App />
          </ProveedorSesion>
        </ProveedorAvisos>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
